import { logEvent } from 'firebase/analytics';
import React from 'react';
import { Navigate, useRoutes, useLocation } from 'react-router-dom';

import { analytics } from '@/utils/firebase';

import { aprilRoutes } from './april';

export const AppRoutes = () => {
  const commonRoutes = [{ path: '/', element: <Navigate to="april" /> }];
  const element = useRoutes([...aprilRoutes, ...commonRoutes]);
  const { pathname } = useLocation();
  React.useEffect(() => {
    logEvent(analytics, 'page_view', {
      page_path: pathname,
    });
  }, [pathname]);

  return <>{element}</>;
};
